import React, {Component} from 'react';
import PropTypes from 'prop-types'
import Modal from 'react-bootstrap/lib/Modal';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import Button from 'react-bootstrap/lib/Button';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import FormControl from 'react-bootstrap/lib/FormControl';
import HelpBlock from 'react-bootstrap/lib/HelpBlock';

import { closeResendEmailModal, updateField } from '../actions/resendEmail.js'
import { resendEmail } from '../actions/auth.js'

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

class ResendEmail extends Component {

	static defaultProps = {}

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

	updateField(event) {
		const { dispatch } = this.props
		dispatch(updateField(event.target.name, event.target.value))
	}

	close() {
		const { dispatch } = this.props
		dispatch(closeResendEmailModal())
	}

	resendEmail() {
		const { dispatch } = this.props
		let account = this.props.account
		dispatch(resendEmail(account._id, {email: this.props.info.email, oldEmail: account.email}))
	}

	render() {

		let account = this.props.account
		let email = this.props.info.email
		if (!email) {
			email = account.email
		}

		return (
			<div style={{ height: 120, width: 200}}>
				<Modal
					show={this.props.showResendEmailModal}
					onHide={this.close.bind(this)}>
					<Modal.Header>
						Resend Activation Email
          </Modal.Header>
			    <Modal.Body>
						<form>
							<FormGroup>
								<FormControl
									type="text"
									name="email"
									value={email}
									placeholder="Email"
									onChange={this.updateField.bind(this)}
								/>
								<FormControl.Feedback />
								<HelpBlock></HelpBlock>
							</FormGroup>
						</form>
					</Modal.Body>
			    <Modal.Footer>
						<Button bsStyle="primary" block onClick={this.resendEmail.bind(this)}>Resend Email</Button>
						<ControlLabel>{this.props.error}</ControlLabel>
					</Modal.Footer>
			  </Modal>
			</div>
		)
	}
}
const mapStateToProps = state => {
  return {...state.resendEmailReducer, account: state.authReducer.account}
}

export default withRouter(
  connect(mapStateToProps)(ResendEmail)
);



// WEBPACK FOOTER //
// ./src/components/ResendEmail.js